__turbopack_context__.v({
  "compactFilterSection": "fRTq0q_compactFilterSection",
});
